export const QUICKSWITCH_TO = 'quickswitchTo';
